import Fetcher from 'od-modules/utils/fetcher';
import {CATEGORIES, STATES} from './constants';

export const DocumentUploadModel = Backbone.Model.extend({
    defaults: {
        email: null,
        bookingID: null,
        uploadButtons: [],
    },
    init(email, bookingID) {
        this.set('email', email);
        this.set('bookingID', bookingID);
        this.getBookingAttachments();
    },
    getUrl() {
        return Odigeo.Settings.getProperty('serviceAttachmentFormatter')('');
    },
    getBookingAttachments() {
        const bookingid = this.get('bookingID');
        const url = `${this.getUrl()}?bookingid=${bookingid}`;
        return Fetcher.get(url).json()
            .then((categories) => {
                const newButtons = CATEGORIES.map((category) => {
                    return {
                        category: category,
                        state: categories[category] > 0 ? STATES.success : STATES.default,
                        quantity: categories[category],
                    };
                });
                this.set('uploadButtons', newButtons);
                this.trigger('modelUpdated');
            })
            .catch(() => {
                Odigeo.trigger(`${this.id}:onNoBookingAttachments`);
            });
    },
    updateUploadButtons(category, state) {
        const uploadButtons = Odigeo._.clone(this.get('uploadButtons'));
        const newButtons = uploadButtons.map((element) => {
            if (element.category === category) {
                element.state = state;
                if (element.state === STATES.success) {
                    element.quantity = ++element.quantity;
                }
            }
            return element;
        });
        this.set('uploadButtons', newButtons);
        this.trigger('modelUpdated');
    },
    attachFile(file, category) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('bookingid', this.get('bookingID'));
        formData.append('email', this.get('email'));
        formData.append('category', category);

        const url = this.getUrl();

        return Fetcher.post(url, formData, false).defaultHeaders()
            .then(() => {
                this.updateUploadButtons(category, STATES.success);
            })
            .catch(() => {
                this.updateUploadButtons(category, STATES.failed);
            });
    },
});
